export default __webpack_public_path__ + "static/media/offline.ff1c7a3e.svg";